import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, createBlock as _createBlock, Fragment as _Fragment } from "vue";
const _hoisted_1 = { key: 0 };
const _hoisted_2 = ["href"];
const _hoisted_3 = { class: "ms-2" };
const _hoisted_4 = {
    key: 0,
    class: "d-block small text-secondary mt-1"
};
const _hoisted_5 = {
    key: 1,
    class: "vertical-align-middle"
};
const _hoisted_6 = {
    key: 0,
    class: "d-block small text-secondary"
};
const _hoisted_7 = { key: 2 };
const _hoisted_8 = { class: "d-block fw-bold" };
const _hoisted_9 = {
    key: 0,
    class: "d-block small"
};
const _hoisted_10 = {
    key: 1,
    class: "d-block small"
};
const _hoisted_11 = { key: 3 };
const _hoisted_12 = ["min", "step", "disabled"];
const _hoisted_13 = { key: 4 };
const _hoisted_14 = { class: "d-block fw-bold" };
const _hoisted_15 = {
    key: 0,
    class: "d-block text-danger"
};
const _hoisted_16 = {
    key: 1,
    class: "d-block small"
};
const _hoisted_17 = {
    key: 2,
    class: "d-block small"
};
import { onMounted, ref, watch } from 'vue';
import axios from 'axios';
import { responseMessages } from '@/Composables/responseMessages';
import ConfigurationPriceComposition from '../Shared/ConfigurationPriceComposition.vue';
import { debounce } from 'lodash';
import { formatters } from '@/Composables/formatters';
import Swal from 'sweetalert2';
import { useI18n } from 'vue-i18n';
import { useTrans } from '@/Composables/useTrans';
export default /*@__PURE__*/ _defineComponent({
    __name: 'OrderPosition',
    props: {
        orderPositionUuid: {
            type: String,
            required: true
        },
        taxIncluded: {
            type: Boolean,
            default: false
        },
        configuratorUrl: {
            type: String,
            required: true
        },
        canChange: {
            type: Boolean,
            default: true
        }
    },
    emits: ['update', 'remove'],
    setup(__props, { emit: __emit }) {
        const { t } = useI18n();
        const { trans } = useTrans();
        let { showErrorSwal, showSuccessSwal } = responseMessages();
        let { formatCurrency } = formatters();
        const emit = __emit;
        const props = __props;
        const key = ref('');
        const orderPosition = ref(null);
        const changesPossible = ref(props.canChange);
        onMounted(() => {
            updateOrderPosition();
        });
        const debouncedAmountUpdate = debounce(() => {
            if (orderPosition && orderPosition.value.amount && !isNaN(orderPosition.value.amount) && orderPosition.value.amount >= orderPosition.value.minOrderAmount && orderPosition.value.amount <= orderPosition.value.maxOrderAmount) {
                if (orderPosition.value.productsAmountSteps > 1) {
                    orderPosition.value.amount = Math.round(orderPosition.value.amount / orderPosition.value.productsAmountSteps) * orderPosition.value.productsAmountSteps;
                }
                updateAmountWithPreCheck();
            }
            else {
                if (orderPosition.value.amount > orderPosition.value.maxOrderAmount) {
                    Swal.fire({
                        title: t('Höhere Stückzahl? - Kein Problem!'),
                        html: trans('Bitte kontaktieren Sie uns bei mehr als {max} gewünschten Produkten.<br />Wir erstellen gerne ein individuelles Angebot für Sie.', { max: orderPosition.value.maxOrderAmount }),
                        icon: 'info',
                        confirmButtonText: t("Ok"),
                        confirmButtonColor: "#528399",
                        timer: 10000
                    });
                }
                else {
                    orderPosition.value.amount = orderPosition.value.minOrderAmount;
                }
            }
        }, 500);
        watch(() => orderPosition.value && orderPosition.value.amount, (newAmount, oldAmount) => {
            if (orderPosition.value && newAmount != oldAmount && oldAmount != null) {
                debouncedAmountUpdate();
            }
        });
        function updateOrderPosition() {
            axios.post(route('cart.orderPositions.load', props.orderPositionUuid))
                .then(response => {
                orderPosition.value = response.data;
                if (changesPossible.value == true) {
                    changesPossible.value = orderPosition.value.canChange;
                }
            })
                .catch(error => {
                console.error(error);
                showErrorSwal(t('Ein Fehler ist aufgetreten.'));
            });
        }
        function updateAmountWithPreCheck() {
            if (!changesPossible.value) {
                return;
            }
            if (orderPosition.value.originTotalPrice) {
                Swal.fire({
                    title: t('Menge ändern und Angebots-Preis verwerfen?'),
                    text: t('Für die aktuelle Menge wurde ein Angebotspreis erstellt. Möchten Sie die Menge trotzdem ändern und den Angebotspreis verwerfen?'),
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: t('Ja, Angebotspreis verwerfen und Menge ändern'),
                    cancelButtonText: t("Abbrechen"),
                    confirmButtonColor: "#528399",
                    cancelButtonColor: "#dc3545",
                }).then((result) => {
                    if (!result.isConfirmed) {
                        updateOrderPosition();
                        return;
                    }
                    updateAmount();
                });
            }
            else {
                updateAmount();
            }
        }
        function updateAmount() {
            axios.put(route('cart.orderPositions.amount.update', props.orderPositionUuid), {
                amount: orderPosition.value.amount
            })
                .then(response => {
                updateOrderPosition();
                emit('update', props.orderPositionUuid);
            })
                .catch(error => {
                console.error(error);
                showErrorSwal(t('Ein Fehler ist aufgetreten.'));
            });
        }
        function removeOrderPosition() {
            if (!changesPossible.value) {
                showErrorSwal(t('Diese Position kann nicht gelöscht werden.'));
                return;
            }
            Swal.fire({
                title: t('Position löschen?'),
                text: t('Soll die Position wirklich gelöscht werden? Konfigurationen werden dadurch nicht gelöscht.'),
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: t('Ja, löschen'),
                cancelButtonText: t("Abbrechen"),
                confirmButtonColor: "#528399",
                cancelButtonColor: "#dc3545",
            }).then((result) => {
                if (result.isConfirmed) {
                    axios.delete(route('cart.orderPositions.destroy', props.orderPositionUuid))
                        .then(response => {
                        emit('remove', props.orderPositionUuid);
                    })
                        .catch(error => {
                        console.error(error);
                        showErrorSwal(t('Ein Fehler ist aufgetreten.'));
                    });
                }
            });
        }
        function showConfigurationPriceOverview() {
            key.value = Math.random().toString(36).substring(7);
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                (orderPosition.value && orderPosition.value.configurationUuid)
                    ? (_openBlock(), _createElementBlock("td", _hoisted_1, [
                        _createElementVNode("button", {
                            class: "btn d-flex align-items-center p-0 mb-2",
                            onClick: _cache[0] || (_cache[0] = ($event) => (showConfigurationPriceOverview()))
                        }, [
                            _createElementVNode("span", null, _toDisplayString(orderPosition.value.productDetails), 1),
                            _cache[3] || (_cache[3] = _createElementVNode("span", { class: "d-flex align-items-center ms-2" }, [
                                _createElementVNode("svg", {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    width: "16",
                                    height: "16",
                                    fill: "currentColor",
                                    class: "bi bi-info-circle-fill",
                                    viewBox: "0 0 16 16"
                                }, [
                                    _createElementVNode("path", { d: "M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16m.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2" })
                                ])
                            ], -1))
                        ]),
                        _createElementVNode("a", {
                            href: orderPosition.value.configurationUrl,
                            target: "_top",
                            class: "btn btn-sm btn-primary d-inline-flex align-items-center"
                        }, [
                            _cache[4] || (_cache[4] = _createElementVNode("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                height: "12",
                                fill: "currentColor",
                                class: "bi bi-arrow-return-right",
                                viewBox: "0 0 16 16"
                            }, [
                                _createElementVNode("path", {
                                    "fill-rule": "evenodd",
                                    d: "M1.5 1.5A.5.5 0 0 0 1 2v4.8a2.5 2.5 0 0 0 2.5 2.5h9.793l-3.347 3.346a.5.5 0 0 0 .708.708l4.2-4.2a.5.5 0 0 0 0-.708l-4-4a.5.5 0 0 0-.708.708L13.293 8.3H3.5A1.5 1.5 0 0 1 2 6.8V2a.5.5 0 0 0-.5-.5"
                                })
                            ], -1)),
                            _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(t)('Konfiguration')), 1)
                        ], 8, _hoisted_2),
                        (orderPosition.value.deliveryDays && orderPosition.value.deliveryDays > 0)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_unref(trans)('{days} Tag(e) Lieferzeit', { days: orderPosition.value.deliveryDays })), 1))
                            : _createCommentVNode("", true)
                    ]))
                    : _createCommentVNode("", true),
                (orderPosition.value && orderPosition.value.configurationUuid == null)
                    ? (_openBlock(), _createElementBlock("td", _hoisted_5, [
                        _createTextVNode(_toDisplayString(orderPosition.value.productDetails), 1),
                        (orderPosition.value.deliveryDays && orderPosition.value.deliveryDays > 0)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_unref(trans)('{days} Tag(e) Lieferzeit', { days: orderPosition.value.deliveryDays })), 1))
                            : _createCommentVNode("", true)
                    ]))
                    : _createCommentVNode("", true),
                (orderPosition.value)
                    ? (_openBlock(), _createElementBlock("td", _hoisted_7, [
                        _createElementVNode("span", _hoisted_8, _toDisplayString(!__props.taxIncluded ? _unref(formatCurrency)(orderPosition.value.singlePrice) : _unref(formatCurrency)(orderPosition.value.singlePriceInclTax)), 1),
                        (!__props.taxIncluded)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_unref(t)('exkl. MwSt.')), 1))
                            : _createCommentVNode("", true),
                        (__props.taxIncluded)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_unref(t)('inkl. MwSt.')), 1))
                            : _createCommentVNode("", true)
                    ]))
                    : _createCommentVNode("", true),
                (orderPosition.value)
                    ? (_openBlock(), _createElementBlock("td", _hoisted_11, [
                        _withDirectives(_createElementVNode("input", {
                            type: "number",
                            class: "form-control",
                            min: orderPosition.value.minOrderAmount,
                            step: orderPosition.value.productsAmountSteps,
                            max: "99999",
                            style: { "width": "150px" },
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((orderPosition.value.amount) = $event)),
                            disabled: !changesPossible.value
                        }, null, 8, _hoisted_12), [
                            [_vModelText, orderPosition.value.amount]
                        ])
                    ]))
                    : _createCommentVNode("", true),
                (orderPosition.value)
                    ? (_openBlock(), _createElementBlock("td", _hoisted_13, [
                        _createElementVNode("span", _hoisted_14, _toDisplayString(!__props.taxIncluded ? _unref(formatCurrency)(orderPosition.value.totalPrice) : _unref(formatCurrency)(orderPosition.value.totalPriceInclTax)), 1),
                        (orderPosition.value.originTotalPrice)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_15, [
                                _createElementVNode("del", null, _toDisplayString(!__props.taxIncluded ? _unref(formatCurrency)(orderPosition.value.originTotalPrice) : _unref(formatCurrency)(orderPosition.value.originTotalPriceInclTax)), 1)
                            ]))
                            : _createCommentVNode("", true),
                        (!__props.taxIncluded)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(_unref(t)('exkl. MwSt.')), 1))
                            : _createCommentVNode("", true),
                        (__props.taxIncluded)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(_unref(t)('inkl. MwSt.')), 1))
                            : _createCommentVNode("", true)
                    ]))
                    : _createCommentVNode("", true),
                _createElementVNode("td", null, [
                    (orderPosition.value && changesPossible.value)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: "btn",
                            onClick: _cache[2] || (_cache[2] = ($event) => (removeOrderPosition()))
                        }, [...(_cache[5] || (_cache[5] = [
                                _createElementVNode("svg", {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    height: "24",
                                    fill: "currentColor",
                                    class: "bi bi-x-circle text-danger",
                                    viewBox: "0 0 16 16"
                                }, [
                                    _createElementVNode("path", { d: "M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" }),
                                    _createElementVNode("path", { d: "M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" })
                                ], -1)
                            ]))]))
                        : _createCommentVNode("", true)
                ]),
                (orderPosition.value && orderPosition.value.configurationUuid && key.value != '')
                    ? (_openBlock(), _createBlock(ConfigurationPriceComposition, {
                        configurationId: orderPosition.value.configurationUuid,
                        amount: orderPosition.value.amount,
                        key: key.value
                    }, null, 8, ["configurationId", "amount"]))
                    : _createCommentVNode("", true)
            ], 64));
        };
    }
});
